<template>
  <div class="login-content">
    <div class="img-left">
      <img src="@/assets/img/login-left.png" alt="" />
    </div>

    <div class="box">
      <img src="@/assets/img/login-logo.png" alt="" />
      <p>内部数据运营平台</p>
      <el-form
        :model="loginForm"
        :rules="rules"
        ref="loginForm"
        label-width="0"
        class="demo-ruleForm"
      >
        <el-form-item prop="UserName">
          <el-input
            v-model="loginForm.UserName"
            placeholder="请输入账号/手机号"
            prefix-icon="el-icon-mobile-phone"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="PassWord">
          <el-input
            v-model="loginForm.PassWord"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            class="btn"
            @click="submitForm('loginForm')"
            :loading="isLoading"
            >登录</el-button
          >
        </el-form-item>
      </el-form>
      <!-- <el-checkbox v-model="checked">自动登录</el-checkbox> -->
    </div>
    <div class="img-right">
      <img src="@/assets/img/login-right.png" alt="" />
    </div>
    <a
      href="https://beian.miit.gov.cn"
      target="_blank"
      class="footer"
      v-text="
        ' Copyright © ' +
        new Date().getFullYear() +
        ' Beijing HexFuture Technology Co., Ltd. All Rights Reserved 京ICP备16054026号-1'
      "
      >京ICP备16054026号-1</a
    >
  </div>
</template>

<script>
import axios from "axios";
import loginBaseURL from "@/api/loginConfig.js";
import { Message } from "element-ui";
export default {
  data() {
    return {
      loginForm: {},
      rules: {
        UserName: [
          { required: true, message: "请输入账号/手机号", trigger: "blur" },
        ],
        PassWord: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      isLoading: false,
    };
  },
  created() {
    // 按下回车执行登录按钮点击事件
    var _self = this;
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key == 13) {
        _self.submitForm("loginForm");
      }
    };
  },
  beforeDestroy() {
    document.onkeydown = null;
  },
  mounted() {},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          axios({
            method: "post",
            url: `${loginBaseURL}/User/Login`,
            data: this.loginForm,
          })
            .then((res) => {
              if (res.data.ErrorCode) {
                this.isLoading = false;
                this.$message.error(res.data.ErrorMessage);
                return;
              }
              // 登录成功,获取个人信息
              axios({
                method: "get",
                url: `${loginBaseURL}/User/GetUserRoleForHeadMaster`,
                params: {
                  ssotoken: res.data.ssotoken,
                },
              }).then((res2) => {
                if (res2.data.ErrorCode) {
                  this.isLoading = false;
                  this.$message.error(res2.data.ErrorMessage);
                  return;
                }
                if (res2.data.RoleList.some((el) => el.RoleName == "校长")) {
                  sessionStorage.setItem("userInfo", JSON.stringify(res.data));
                  let obj = {
                    provinceIds: [],
                    cityIds: [],
                    localeIds: [],
                    loginUserId: res.data.Key,
                  };
                  axios
                    .all([
                      this.$API.loginApi.getAddress({
                        loginUserId: res.data.Key,
                      }),
                      this.$API.basicsApi.getSchoolList(obj),
                    ])
                    .then(
                      axios.spread((res3, res4) => {
                        sessionStorage.setItem(
                          "cityList",
                          JSON.stringify(res3.result)
                        );
                        let data = res4.result.map((el) => {
                          el.label = el.schoolName;
                          el.value = el.schoolId;
                          delete el.schoolId;
                          delete el.schoolName;
                          delete el.total;
                          return el;
                        });
                        sessionStorage.setItem(
                          "schoolList",
                          JSON.stringify(data)
                        );
                        if (res3.result && data) {
                          Message({
                            message: "登录成功!",
                            type: "success",
                            duration: 1000,
                          });
                          setTimeout(() => {
                            this.$router.replace("/");
                          }, 1000);
                        }
                      })
                    )
                    .finally(() => (this.isLoading = false));
                } else {
                  this.isLoading = false;
                  this.$message.error("暂无权限登录!");
                }
              });
            })
            .catch((err) => {
              Message({
                message: err,
                type: "error",
                duration: 1000,
              });
            })
            .finally(() => (this.isLoading = false));
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-content {
  width: 100%;
  height: 100%;
  background: #48618b;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;
  .footer {
    display: block;
    width: 100%;
    font-size: 12px;
    margin-top: 5px;
    text-align: center;
    position: absolute;
    bottom: 10px;
    color: #717994;
  }
  .img-left {
    flex: 1;
    text-align: end;
    img {
      width: 159px;
      height: 303px;
      margin-right: 115px;
    }
  }
  .box {
    width: 560px;
    height: 495px;
    background: #ffffff;
    box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.08),
      0px 9px 28px 0px rgba(0, 0, 0, 0.06),
      0px 12px 48px 16px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    flex-shrink: 0;
    padding: 0 93px 0 93px;
    text-align: center;
    img {
      width: 223px;
      height: 53px;
      display: block;
      margin: 0 auto;
      margin-top: 56px;
    }
    p {
      // width: 128px;
      height: 24px;
      color: #48618b;
      line-height: 24px;
      text-align: center;
      margin-top: 24px;
      font-weight: 600;
    }
    .demo-ruleForm {
      margin-top: 40px;
      .btn {
        width: 100%;
        height: 46px;
        background: #48618b;
        border-radius: 2px;
        margin-top: 18px;
        font-size: 18px;
        color: #ffffff;
        // line-height: 46px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .img-right {
    margin-top: 42px;
    flex: 1;
    img {
      width: 372px;
      height: 323px;
      padding-left: 68px;
    }
    @media screen and (max-width: 1400px) {
      img {
        padding-left: 0;
      }
    }
  }
}
</style>
